(function () {
  'use strict';

  var SELECTOR = '.mogo3-pro .media_comment, .mogo3-pro .moreside .media_comment';

  function hideNode(node) {
    if (!node || node.nodeType !== 1) return;

    try {
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('max-height', '0', 'important');
      node.style.setProperty('overflow', 'hidden', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('padding', '0', 'important');
    } catch (e) {
      // ignore
    }
  }

  function scanAndHide(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes;
    try {
      nodes = scope.querySelectorAll(SELECTOR);
    } catch (e) {
      nodes = [];
    }

    for (var i = 0; i < nodes.length; i++) {
      hideNode(nodes[i]);
    }
  }

  function start() {
    // First pass ASAP
    scanAndHide(document);

    // Keep re-applying in case some script sets display:block !important later.
    var ticks = 0;
    var interval = window.setInterval(function () {
      ticks++;
      scanAndHide(document);
      if (ticks >= 40) {
        window.clearInterval(interval);
      }
    }, 500);

    // Observe DOM mutations for hydration re-renders.
    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.addedNodes && m.addedNodes.length) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              if (!n || n.nodeType !== 1) continue;
              if (n.matches && n.matches(SELECTOR)) {
                hideNode(n);
              }
              scanAndHide(n);
            }
          }
          if (m.type === 'attributes' && m.target) {
            // If someone toggles style/class on the node, enforce hidden.
            if (m.target.matches && m.target.matches(SELECTOR)) {
              hideNode(m.target);
            }
          }
        }
      });

      obs.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) {
      // ignore
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
